import React, { useState } from "react";
import {
  Grid,
  Card,
  CardActionArea,
  CardContent,
  Typography,
  Dialog,
  DialogContent,
  IconButton,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CloseIcon from "@mui/icons-material/Close";

const documents = [
  {
    name: "MBE Udyam Registration Certificate",
    url: "/MBE_Udyam_Registration_Certificate._08-12-23 (1).pdf",
  },
  {
    name: "Modern Boilers GST Certificate",
    url: "/Modern Boilers GST Certificate three page..pdf",
  },
  {
    name: "Modern Boiler Manufacturing License",
    url: "/Modern_Boiler_mnufaturing_license 300 kg..pdf",
  },
];

function SafetyQualityContent() {
  const [fullscreenPdf, setFullscreenPdf] = useState(null);

  const handleFullscreen = (pdfUrl) => {
    setFullscreenPdf(pdfUrl);
  };

  const closeFullscreen = () => {
    setFullscreenPdf(null);
  };

  return (
    <Grid container spacing={3} padding={3}>
      {/* Safety Policy Section */}
      <Grid item xs={12} md={6}>
        <Typography variant="h4" gutterBottom>
          Safety Policy
        </Typography>
        <Typography variant="body1">
          We are committed to providing a Safe Working Environment to Employees.
        </Typography>
        <Typography variant="body1">
          Modern Boilers & Pressure Equipments is developing and documenting its occupational Health and Safety
          management systems (Safety first, luck afterwards).
        </Typography>
      </Grid>

      {/* Policy Fulfillment Section */}
      <Grid item xs={12} md={6}>
        <Typography variant="h5" gutterBottom>
          To Fulfill Policy
        </Typography>
        <Typography variant="body1">
          Modern Boilers & Pressure Equipments (MBPE) implement safety programs and training, motivating employees to
          involve in this process and commit to achieving this objective.
        </Typography>
        <Typography variant="body1">
          MBPE insists on educating employees on personal safety and the protection of physical assets to minimize hazards.
        </Typography>
      </Grid>

      {/* Documents Section */}
      <Grid item xs={12}>
        <Typography variant="h5" gutterBottom>
          Our Documents
        </Typography>
        <Grid container spacing={2}>
          {documents.map((doc, index) => (
            <Grid item xs={12} sm={4} key={index}>
              <Card>
                <CardActionArea onClick={() => handleFullscreen(doc.url)}>
                  <CardContent style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <PictureAsPdfIcon color="primary" fontSize="large" />
                    <Typography variant="body1">{doc.name}</Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Fullscreen PDF Viewer */}
      <Dialog open={Boolean(fullscreenPdf)} onClose={closeFullscreen} maxWidth="lg" fullWidth>
        <DialogContent style={{ position: "relative" }}>
          <IconButton
            onClick={closeFullscreen}
            style={{ position: "absolute", top: 10, right: 10, background: "white" }}
          >
            <CloseIcon />
          </IconButton>
          {fullscreenPdf && (
            <embed src={fullscreenPdf} type="application/pdf" width="100%" height="600px" />
          )}
        </DialogContent>
      </Dialog>
    </Grid>
  );
}

export default SafetyQualityContent;
